import { withConfig } from "@/utils/withConfig";
import { DonationSource } from "./DonationSource";
import type { DonationSourceProps } from "./DonationSourceProps";

export * from "./DonationSource";
export * from "./DonationSourceProps";

export const DonationSourceWithConfig = withConfig<DonationSourceProps>(
  DonationSource,
  "donation_source",
);
